export type PriceInput = number | string | null | undefined;

/** Normalize API price values (number or pre-formatted string) to a number. */
export function toPriceNumber(raw: PriceInput): number | null {
  if (raw == null || raw === '') return null;
  if (typeof raw === 'number') return Number.isFinite(raw) ? raw : null;

  const trimmed = raw.trim();
  if (!trimmed) return null;

  const cleaned = trimmed.replace(/Rs\.?/gi, '').replace(/[₹,\s]/g, '');
  const n = parseFloat(cleaned);
  return Number.isFinite(n) ? n : null;
}

/** Strip currency symbols, commas and whitespace then parse to a number. */
export function parsePrice(raw: string | undefined | null): number {
  return toPriceNumber(raw) ?? 0;
}

/** Display price with a single rupee symbol and Indian grouping. */
export function formatDisplayPrice(value: number | null | undefined): string {
  if (value == null) return '';
  return `₹ ${value.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
}

/** Pick the first parseable price from API field aliases. */
export function mapPriceField(...sources: PriceInput[]): number | null {
  for (const source of sources) {
    const parsed = toPriceNumber(source);
    if (parsed != null) return parsed;
  }
  return null;
}

export function formatPrice(
  price: number | string,
  fractionDigits: number = 0,
  currency: string = "INR",
  locale: string = "en-IN"
): string {
  const numericPrice = Number(price);

  const formattedPrice = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    maximumFractionDigits: fractionDigits,
  }).format(numericPrice);

  return formattedPrice.replace(/(\D)(\d)/, "$1 $2");
}